import { render, staticRenderFns } from "./Sleep.vue?vue&type=template&id=54bb0dec"
import script from "./Sleep.vue?vue&type=script&lang=js"
export * from "./Sleep.vue?vue&type=script&lang=js"
import style0 from "./Sleep.vue?vue&type=style&index=0&id=54bb0dec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports